import { Heading } from 'blaze-ui/Heading/Heading'
import { ChannelOption } from 'components/Wizards/CampaignWizard/Types'
import Styles from './TextChannels.module.scss'
import { ChannelIcon } from 'components/ChannelIcon/ChannelIcon'
import { Edit1, Trash2 } from 'blaze-ui/icons'
import { IconButton } from 'blaze-ui/IconButton/IconButton'
import { useChannelsListContext } from './ChannelsListContext/ChannelsListContext'
import { RenamingInput } from './RenamingInput'

interface Props {
  channels: ChannelOption[]
}

export const TextChannels = ({ channels }: Props) => {
  const { editingChannelType, setEditingChannelType, removeChannelType, updateChannels } = useChannelsListContext()

  return (
    <div className={Styles.textChannels}>
      <Heading level={4}>Text content we'll generate for you</Heading>
      <div className={Styles.container}>
        {channels.map((channel: ChannelOption, index: number) => (
          <div key={`${channel.channel_type}-${channel.title}-${index}`} className={Styles.item}>
            <div className={Styles.details}>
              <div className={Styles.icon}>
                <ChannelIcon channel={channel.channel_type} size={20} />
              </div>
              {editingChannelType === channel.channel_type ? (
                <RenamingInput
                  initialValue={channel.title}
                  onCommit={(newTitle) => {
                    updateChannels([{ ...channel, title: newTitle }])
                    setEditingChannelType(undefined)
                  }}
                />
              ) : (
                <span>{channel.title}</span>
              )}
            </div>
            <div className={Styles.actions}>
              <IconButton
                icon={Edit1}
                variant="ghost"
                onPress={() => setEditingChannelType(channel.channel_type)}
                aria-label="Edit"
              />
              <IconButton
                icon={Trash2}
                variant="ghost"
                onPress={() => removeChannelType(channel.channel_type)}
                aria-label="Remove"
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
